import { createAction, props } from '@ngrx/store';
import {
  SubmittalPackageDocumentCategory,
  SubmittalRegistryPartialUpdateDto,
} from '@app/store/submittals/submittals.types';

import { FileUploadResp } from '@app/framework/interfaces/file.type';

const onPackageDetailsOpen = createAction(
  '[Submittal Package Details] On Package Details Open',
  props<{ packageId: number }>(),
);

const onPackageDetailsClose = createAction('[Submittal Package Details] On Package Details Close');

const newVersionSelected = createAction(
  '[Submittal Package Details] New Version Selected',
  props<{ packageId: number }>(),
);

const saveEntryClicked = createAction(
  '[Submittal Package Details] Save Entry Clicked',
  props<{ registryEntryId: number; registryEntryPayload: SubmittalRegistryPartialUpdateDto }>(),
);

const unlockEntryClicked = createAction(
  '[Submittal Package Details] Unlock Entry Clicked',
  props<{ registryEntryId: number }>(),
);

const uploadFilesToCategorySuccess = createAction(
  '[Submittal Package Details] Upload Files To Category Success',
  props<{
    packageId: number;
    documentCategory: SubmittalPackageDocumentCategory;
    files: FileUploadResp[];
  }>(),
);

const uploadFilesToCategoryFailure = createAction(
  '[Submittal Package Details] Upload Files To Category Failure',
  props<{ packageId: number; documentCategory: SubmittalPackageDocumentCategory }>(),
);

const deleteFileClicked = createAction(
  '[Submittal Package Details] Delete File Clicked',
  props<{
    packageId: number;
    fileId: number;
  }>(),
);

const deleteAllFilesInCategorySelected = createAction(
  '[Submittal Package Details] Delete All Files In Category Selected',
  props<{
    packageId: number;
    documentCategory: SubmittalPackageDocumentCategory;
  }>(),
);

const downloadAllFilesInCategorySelected = createAction(
  '[Submittal Package Details] Download All Files In Category Clicked',
  props<{
    packageId: number;
    documentCategory: SubmittalPackageDocumentCategory;
  }>(),
);

const requestSubmittals = createAction(
  '[Submittal Package Details] Request Submittals Selected',
  props<{ packageId: number }>(),
);
const cancelSubmittalRequest = createAction(
  '[Submittal Package Details] Cancel Submittal Request Selected',
  props<{ packageId: number }>(),
);

const sendPackageForApproval = createAction(
  '[Submittal Package Details] Send Package For Approval Selected',
  props<{ packageId: number }>(),
);

const cancelPackageApproval = createAction(
  '[Submittal Package Details] Cancel Package Approval Selected',
  props<{ packageId: number }>(),
);

const markAsComplete = createAction(
  '[Submittal Package Details] Mark As Complete Selected',
  props<{ packageId: number }>(),
);

const markAsReady = createAction(
  '[Submittal Package Details] Mark As Ready Selected',
  props<{ packageId: number }>(),
);

const submitToOwner = createAction(
  '[Submittal Package Details] Submit To Owner Selected',
  props<{ packageId: number }>(),
);

const cancelSubmitToOwner = createAction(
  '[Submittal Package Details] Cancel Submit To Owner Selected',
  props<{ packageId: number }>(),
);

const createRevision = createAction(
  '[Submittal Package Details] Create Revision Selected',
  props<{ packageId: number }>(),
);

const voidPackage = createAction(
  '[Submittal Package Details] Void Package Selected',
  props<{ packageId: number }>(),
);

const deletePackage = createAction(
  '[Submittal Package Details] Delete Package Selected',
  props<{ packageId: number }>(),
);

const closePackage = createAction(
  '[Submittal Package Details] Close Package',
  props<{ packageId: number }>(),
);

const reopenPackage = createAction(
  '[Submittal Package Details] Reopen Package',
  props<{ packageId: number }>(),
);

export const submittalPackageDetailsActions = {
  // general actions
  onPackageDetailsOpen,
  onPackageDetailsClose,
  newVersionSelected,

  // entry actions
  saveEntryClicked,
  unlockEntryClicked,

  // file actions
  uploadFilesToCategorySuccess,
  uploadFilesToCategoryFailure,
  deleteFileClicked,
  deleteAllFilesInCategorySelected,
  downloadAllFilesInCategorySelected,

  // menu options
  requestSubmittals,
  cancelSubmittalRequest,
  sendPackageForApproval,
  cancelPackageApproval,
  markAsComplete,
  markAsReady,
  submitToOwner,
  cancelSubmitToOwner,
  createRevision,
  voidPackage,
  deletePackage,
  closePackage,
  reopenPackage,
};
